import { formatImageUrl, slugify } from '@/helpers';
import { IngredientMetadata, MBV2NutritionSummary, Recipe, INGREDIENTS_METADATA_COUNTRIES } from '@/models';
import { Routes } from '@/router';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgIngredients',
})
export default class CmgIngredients extends Vue {

  get ingredients(): IngredientMetadata[] {
    return this.$appStore.state.ui.ingredientsPage.visibleIngredients;
  }

  get isRecipe(): boolean {
    return !!this.recipe;
  }

  get recipe(): Recipe | null {
    return this.$appStore.state.ui.ingredientsPage.selectedRecipe;
  }

  get ingredient(): IngredientMetadata | null {
    return this.$appStore.state.ui.ingredientsPage.selectedIngredient;
  }

  get fat(): string | number {
    return this.getNutrititionValue('tfat');
  }

  get carbs(): string | number {
    return this.getNutrititionValue('carb');
  }

  get protein(): string | number {  
    return this.getNutrititionValue('prot');
  }

  get calories(): string | number {
    return this.getNutrititionValue('tcal');
  }

  async mounted() {  
    const isIngredientNavigation = this.$router.currentRoute.params['ingredientNavigation'];
    const ingredientName = this.$router.currentRoute.params['ingredientName'];

    if (!isIngredientNavigation) {
      await this.$services.monoMenu.awaitCacheItemsAndBuildMenu();
      await this.$services.metadata.refreshIngredientsMetadata(false);
    }

    // Default to US right now. Does not exist for CA
    const ingredientsMetadata = this.$appStore.state.menu.ingredientsMetadata[INGREDIENTS_METADATA_COUNTRIES.US];

    if (ingredientsMetadata.data) {
      if (!this.recipe) {
        this.$services.ui.setIngredients(ingredientsMetadata.data.ingredients);
      }

      this.$services.monoMenu.buildRecipeGroups(ingredientsMetadata.data!.ingredientGroups);
    }

    if (ingredientName) {
      const ingredient = this.ingredients.find(i => slugify(i.metaTitle) == ingredientName);

      if (ingredient) {
        this.$services.ui.setIngredient(null);
        this.$services.ui.setIngredientPanelVisibility(false);
        this.selectIngredient(ingredient);
      }
    }
  }

  getIngredientUrl(relativeUrl: string): string {
    return formatImageUrl(relativeUrl);
  }

  selectIngredient(ingredient: IngredientMetadata) {
    this.$services.ui.setIngredient(ingredient);
    this.$services.ui.setIngredientPanelVisibility(true);
    
    const title = slugify(ingredient.metaTitle);
    // this.$router.push({ name: Routes.IngredientsLandingPageIngredientSelect, params: { ingredientName: title, ingredientNavigation: 'true'  } });
    window.history.pushState({}, '', '/ingredients/' + title);
  }

  isIngredientSelected(ingredient: IngredientMetadata) {
    return ingredient.key == this.ingredient?.key;
  }

  getNutrititionValue(key: keyof MBV2NutritionSummary): number | string {
    const nutritionValue = this.recipe?  this.recipe.nutrition[key] : -1;

    if (!nutritionValue && nutritionValue !== 0) {
      return '???';
    }
    return nutritionValue;
  }
}
